<template>
	<div class="page relative">
		<div v-if="!show || (!shareUrl && !shareTitle)"  class="w-100 text-center py-5">
			<v-progress-circular
				indeterminate
				size="50"
			></v-progress-circular>
			<div class="mt-2">
				<v-btn :to="{name: 'Home'}" color="accent">Strona główna</v-btn>
			</div>
		</div>
		<post-dialog
			v-if="show"
			ref="newPost"
			@postAdded="close()"
			@closed="close()"
			:share-url="shareUrl"
			:share-title="shareTitle"
			type="Post" />
	</div>
</template>

<script>
import PostDialog from '@/components/wall/dialogs/PostDialog'
export default {
	name: 'Share',
	components: {
		PostDialog,
	},
	data() {
		return {
			group: null,
			drawer: true,
			shareUrl: null,
			shareTitle: null,
			show: false
		}
	},
	methods: {
		close() {
			this.$router.replace({name: 'Home'});
		},
		proceed() {
			let hasContent = false;
			if(this.$route.query.url) {
				hasContent = true;
				this.shareUrl = decodeURIComponent(this.$route.query.url)
			}
			if(this.$route.query.title) {
				hasContent = true;
				this.shareTitle = decodeURIComponent(this.$route.query.title)
			}

			if(hasContent) {
				this.show = true;
				this.$nextTick(() => {
					this.$refs.newPost.showDialog();
				})
			}
			else {
				this.close();
			}
		}
	},
	mounted() {
		this.proceed();
	},
	created() {
		// this.proceed();
	}
}
</script>

